<template>
  <ul class="anchor-nav">
    <li v-for="(anchor, index) in content" :key="`nav-${index}`" class="mb-xxs">
      <button
        class="anchor-nav__link"
        :class="{ 'is-active': current.replace(/#/g, '') === anchor.slug }"
        @click="onAnchorClick(`#${anchor.slug}`)"
      >
        {{ anchor.title }}
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { prefersReducedMotion } from '@/utils/motion'

import type { PropType } from 'vue'

type Anchor = {
  title: string
  slug: string
}

const props = defineProps({
  content: {
    type: Array as PropType<Anchor[]>,
    required: true,
  },
})

const emit = defineEmits(['chosen-link'])
const current = ref(props.content[0].slug)

// Scroll smoothly to details
const onAnchorClick = (link: string) => {
  const el = document.querySelector(link)

  current.value = link

  if (!el) {
    emit('chosen-link', link)

    return
  }

  const { top } = el.getBoundingClientRect()

  window.scrollTo({
    top: top + window.scrollY + 40,
    left: 0,
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
  })
}
</script>

<style lang="scss" scoped>
.anchor-nav {
  @extend %list-nostyle;

  margin-bottom: $spacing * 4;
}

.anchor-nav__link {
  @extend %button-nostyle;
  @extend %text-nodecoration;

  position: relative;
  will-change: opacity;
  display: inline-block;
  cursor: pointer;
  color: $c-grey-medium;
  transition: color 0.2s;

  &.is-active {
    color: $c-black;
  }

  &:hover {
    color: $c-black;
  }

  &::before {
    position: absolute;
    bottom: -0.2rem;
    left: 0;
    width: 100%;
    height: 0.1rem;
    content: '';
    background-color: $c-grey-medium;
  }
}
</style>
